import React from 'react'

export default function UserNotFound() {
  return (
    <div>User is not Found. Please Login or Register</div>
  )
}
